import * as React from 'react';
import {Box, makeStyles} from '@material-ui/core';
import {useScrollBottom} from './useScrollHook';
import {rieltor} from '../../styles/theme';
import {useIsRieltorApp} from '../../hooks/useIsRieltorApp';

const useStyles = makeStyles({
  bottomBarForIos26: {
    backgroundColor: rieltor.purplePushed, position: 'fixed', bottom: 0, left: 0, width: '100%', minHeight: 10, zIndex: 1301,
    display: 'none',
    'body.dialog-open &': {
      display: 'block',
    }
  },
});

export function BottomBarForIos26() {
  const classes = useStyles();
  const isRieltorApp = useIsRieltorApp();

  if (isRieltorApp) {
    return null;
  }


  setInterval(() => {
    console.log('check dialogs');
    const dialogs = document.querySelectorAll('.MuiDialog-root');
    if (!dialogs.length) {
      document.body.classList.remove('dialog-open');
    }
  }, 1000);


  return (
      <Box className={classes.bottomBarForIos26}/>
  );
}

